export default {
  color_1: 'rgb(62, 136, 79)',
  color_11: 'rgba(62, 136, 79, 0.1)',
  color_2: 'rgb(196, 61, 75)',
  color_22: 'rgba(196, 61, 75, 0.1)',
  color_3: 'rgb(49, 149, 165)',
  color_33: 'rgba(49, 149, 165, 0.1)',
  color_4: 'rgb(226, 134, 59)',
  color_44: 'rgba(226, 134, 59, 0.1)',
  color_5: 'rgb(146, 44, 136)',
  color_55: 'rgba(146, 44, 136, 0.1)',
  color_6: 'rgb(15, 45, 212)',
  color_66: 'rgba(15, 45, 212, 0.1)',
  color_7: 'rgb(207, 19, 19)',
  color_77: 'rgba(207, 19, 19, 0.1)',
  color_8: 'rgb(191, 168, 19)',
  color_88: 'rgba(191, 168, 19, 0.1)',
  color_9: 'rgb(191, 19, 76)',
  color_99: 'rgba(191, 19, 76, 0.1)',
  color_10: 'rgb(226, 134, 59)',
  color_1010: 'rgba(226, 134, 59, 0.1)',
};
